module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Foreword"
    }
  }, [_vm._v("Foreword by Steve Davies MBE")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART 1: THE PASSENGER BUSINESS")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" Passenger Carrying")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter02"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])]), _vm._v(" A Question of Class")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])]), _vm._v(" Getting to the Station: The Omnibus Service")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])]), _vm._v(" Passenger Accommodation")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])]), _vm._v(" Tickets, Please")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])]), _vm._v(" Carrying the Mail")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")])]), _vm._v(" Going to the Races and VIPs")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")])]), _vm._v(" Guards and Porters")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")])]), _vm._v(" Through-Running and Branches")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Summary01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary: Open to All Users")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART 2: CARRYING THE GOODS (‘LUGGAGE’)")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10")])]), _vm._v(" General Merchandize, the Law and Liability")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 11")])]), _vm._v(" Cotton to Manchester")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 12")])]), _vm._v(" Livestock")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 13")])]), _vm._v(" The Coal Trade")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 14")])]), _vm._v(" Price Wars")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 15")])]), _vm._v(" Warehouses and Depôts")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Summary02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary: The Merchandize Business")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART 3: TRAIN WORKING AND TIMETABLES")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 16")])]), _vm._v(" Double-Track Working")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 17")])]), _vm._v(" Train Times")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 18")])]), _vm._v(" Goods Trains")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Summary03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary: L&M Train Working")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART 4: RULES AND REGULATIONS")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 19")])]), _vm._v(" The Railway Police")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 20")])]), _vm._v(" Switchmen and Switches")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 21")])]), _vm._v(" Gates and Gatemen")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 22")])]), _vm._v(" Signalling")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 23")])]), _vm._v(" Fixed Signals")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 24")])]), _vm._v(" Fog Regulations")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chap1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 25")])]), _vm._v(" Accidents and Incidents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang1"
  }, [_vm._v("Appendix")]), _vm._v(" Liverpool & Manchester Railway, Rules and Regulations, March 1839")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0